<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="14" viewBox="0 0 24 14">
    <slot />
    <g
      fill="none"
      fill-rule="evenodd"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M11.5 13C5.148 13 0 6.5 0 6.5S5.148 0 11.5 0 23 6.5 23 6.5 17.852 13 11.5 13z"
        transform="translate(.5 .5)"
      />
      <path
        d="M11.5 9C10.12 9 9 7.881 9 6.5S10.12 4 11.5 4 14 5.119 14 6.5 12.88 9 11.5 9z"
        transform="translate(.5 .5)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
